"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FirstPulseMetricSizeKnownEvent {
    constructor(width, height) {
        this._width = width;
        this._height = height;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
}
exports.FirstPulseMetricSizeKnownEvent = FirstPulseMetricSizeKnownEvent;
//# sourceMappingURL=FirstPulseMetricSizeKnownEvent.js.map